import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ICertification {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  pre_title?: string;
  pre_title_color?: string;
  title?: string;
  title_start_color?: string;
  title_end_color?: string;
  title_gradient_direction?: string;
  apply_now_text?: string;
  apply_now_button_start_color?: string;
  apply_now_button_end_color?: string;
  button_gradient_direction?: string;
  left_navigation_icon?: string;
  alt_text_left_nav_icon?: string;
  right_navigation_icon?: string;
  alt_text_right_nav_icon?: string;
  scroll_frequency?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  variant?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createCertification(payload: Partial<ICertification>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.CERTIFICATION.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateCertification(id: number, payload: Partial<ICertification>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.CERTIFICATION.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
